import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoColorF = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 102,
	height: 25,
	viewBox: "0 0 102 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M23.3987 0.5H18.0957V5.80296H23.3987V0.5Z",
			fill: "#FFA245"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.3098 13.4022C6.56037 13.0742 5.68564 12.8008 5.68564 12.0355C5.68564 11.3248 6.56037 10.8874 7.7631 10.8874C9.78588 10.8874 11.6446 11.7621 12.6287 12.6915L14.6515 9.19265C12.8474 7.88057 10.4966 7.00586 7.70843 7.00586C3.11618 7.00586 0.60137 9.57534 0.60137 12.4728C0.60137 16.6824 4.59226 17.2838 7.43508 17.7758C9.18451 18.0491 10.2779 18.3772 10.2779 19.1972C10.2779 19.9079 9.62187 20.4546 8.03645 20.4546C6.06834 20.4546 3.44419 19.3612 2.18679 18.2678L0 21.9307C1.74943 23.4614 4.81094 24.5002 7.7631 24.5002C12.574 24.5002 15.3622 22.1494 15.3622 18.9785C15.3622 14.5503 11.1526 13.8942 8.3098 13.4022Z",
			fill: "#29ABE2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.3987 7.44336H18.0957V24.0629H23.3987V7.44336Z",
			fill: "#29ABE2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.4911 7.00586C45.867 7.00586 43.6802 8.53661 42.7508 9.95802C42.0401 7.98991 40.4 7.00586 38.0492 7.00586C35.4251 7.00586 33.293 8.48194 32.5823 9.466V7.44322H27.2793V24.0628H32.5823V13.2929C33.129 12.5822 34.113 11.6528 35.5344 11.6528C37.1745 11.6528 37.7212 12.6368 37.7212 13.8942V24.0081H43.0242V13.2382C43.5162 12.5275 44.5549 11.5981 46.031 11.5981C47.6164 11.5981 48.2178 12.5822 48.2178 13.8396V23.9535H53.4661V11.9261C53.4661 8.59128 51.5527 7.00586 48.4911 7.00586Z",
			fill: "#29ABE2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.2932 0.5H75.9902V24.0626H81.2932V0.5Z",
			fill: "#29ABE2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M101.358 16.2997C101.358 10.6688 97.7494 7.06055 92.8292 7.06055C87.6355 7.06055 83.9727 10.9421 83.9727 15.753C83.9727 21.1653 87.9089 24.5002 93.0478 24.5002C95.6173 24.5002 98.3508 23.7895 99.9909 22.3134L97.7494 19.0332C96.82 19.8533 95.1799 20.4546 93.7039 20.4546C91.2437 20.4546 89.7676 19.0332 89.4943 17.5025H101.358V16.2997ZM89.4396 14.0036C89.6583 12.8009 90.533 11.1608 92.8292 11.1608C95.2893 11.1608 96.1093 12.8555 96.2733 14.0036H89.4396Z",
			fill: "#29ABE2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.8936 7.00569C63.6909 7.00569 62.5428 7.27904 61.4495 7.7164V0.5H56.1465V15.7528C56.1465 20.5638 60.028 24.5 64.8936 24.5C69.7046 24.5 73.6408 20.6185 73.6408 15.7528C73.6408 10.8872 69.7046 7.00569 64.8936 7.00569ZM64.8936 19.197C62.9802 19.197 61.4495 17.6663 61.4495 15.7528C61.4495 13.8394 62.9802 12.3087 64.8936 12.3087C66.8071 12.3087 68.3379 13.8394 68.3379 15.7528C68.3379 17.6663 66.8071 19.197 64.8936 19.197Z",
			fill: "#29ABE2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.3098 13.4022C6.56037 13.0742 5.68564 12.8008 5.68564 12.0355C5.68564 11.3248 6.56037 10.8874 7.7631 10.8874C9.78588 10.8874 11.6446 11.7621 12.6287 12.6915L14.6515 9.19265C12.8474 7.88057 10.4966 7.00586 7.70843 7.00586C3.11618 7.00586 0.60137 9.57534 0.60137 12.4728C0.60137 16.6824 4.59226 17.2838 7.43508 17.7758C9.18451 18.0491 10.2779 18.3772 10.2779 19.1972C10.2779 19.9079 9.62187 20.4546 8.03645 20.4546C6.06834 20.4546 3.44419 19.3612 2.18679 18.2678L0 21.9307C1.74943 23.4614 4.81094 24.5002 7.7631 24.5002C12.574 24.5002 15.3622 22.1494 15.3622 18.9785C15.3622 14.5503 11.1526 13.8942 8.3098 13.4022Z",
			fill: "url(#paint0_linear_611_11110)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.3987 7.44336H18.0957V24.0629H23.3987V7.44336Z",
			fill: "url(#paint1_linear_611_11110)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.4911 7.00586C45.867 7.00586 43.6802 8.53661 42.7508 9.95802C42.0401 7.98991 40.4 7.00586 38.0492 7.00586C35.4251 7.00586 33.293 8.48194 32.5823 9.466V7.44322H27.2793V24.0628H32.5823V13.2929C33.129 12.5822 34.113 11.6528 35.5344 11.6528C37.1745 11.6528 37.7212 12.6368 37.7212 13.8942V24.0081H43.0242V13.2382C43.5162 12.5275 44.5549 11.5981 46.031 11.5981C47.6164 11.5981 48.2178 12.5822 48.2178 13.8396V23.9535H53.4661V11.9261C53.4661 8.59128 51.5527 7.00586 48.4911 7.00586Z",
			fill: "url(#paint2_linear_611_11110)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.2932 0.5H75.9902V24.0626H81.2932V0.5Z",
			fill: "url(#paint3_linear_611_11110)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M101.358 16.2997C101.358 10.6688 97.7494 7.06055 92.8292 7.06055C87.6355 7.06055 83.9727 10.9421 83.9727 15.753C83.9727 21.1653 87.9089 24.5002 93.0478 24.5002C95.6173 24.5002 98.3508 23.7895 99.9909 22.3134L97.7494 19.0332C96.82 19.8533 95.1799 20.4546 93.7039 20.4546C91.2437 20.4546 89.7676 19.0332 89.4943 17.5025H101.358V16.2997ZM89.4396 14.0036C89.6583 12.8009 90.533 11.1608 92.8292 11.1608C95.2893 11.1608 96.1093 12.8555 96.2733 14.0036H89.4396Z",
			fill: "url(#paint4_linear_611_11110)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.8936 7.00569C63.6909 7.00569 62.5428 7.27904 61.4495 7.7164V0.5H56.1465V15.7528C56.1465 20.5638 60.028 24.5 64.8936 24.5C69.7046 24.5 73.6408 20.6185 73.6408 15.7528C73.6408 10.8872 69.7046 7.00569 64.8936 7.00569ZM64.8936 19.197C62.9802 19.197 61.4495 17.6663 61.4495 15.7528C61.4495 13.8394 62.9802 12.3087 64.8936 12.3087C66.8071 12.3087 68.3379 13.8394 68.3379 15.7528C68.3379 17.6663 66.8071 19.197 64.8936 19.197Z",
			fill: "url(#paint5_linear_611_11110)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M56.2011 15.7526V8.26287L53.741 5.80273L49.9688 9.57494L56.2011 15.7526Z",
			fill: "#FFA245"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_611_11110",
				x1: 22.3901,
				y1: 44.3303,
				x2: 78.0783,
				y2: -11.3579,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: 324998e-9,
						stopColor: "#5AD7F4"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .1404,
						stopColor: "#56CEEF"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .3724,
						stopColor: "#49B4E1"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .5674,
						stopColor: "#3D9AD2"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8652,
						stopColor: "#0075BE"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .9946,
						stopColor: "#005B97"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_611_11110",
				x1: 22.3902,
				y1: 44.3305,
				x2: 78.0783,
				y2: -11.3578,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: 324998e-9,
						stopColor: "#5AD7F4"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .1404,
						stopColor: "#56CEEF"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .3724,
						stopColor: "#49B4E1"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .5674,
						stopColor: "#3D9AD2"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8652,
						stopColor: "#0075BE"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .9946,
						stopColor: "#005B97"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_611_11110",
				x1: 22.3893,
				y1: 44.3303,
				x2: 78.0774,
				y2: -11.3579,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: 324998e-9,
						stopColor: "#5AD7F4"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .1404,
						stopColor: "#56CEEF"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .3724,
						stopColor: "#49B4E1"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .5674,
						stopColor: "#3D9AD2"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8652,
						stopColor: "#0075BE"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .9946,
						stopColor: "#005B97"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_611_11110",
				x1: 22.3898,
				y1: 44.3302,
				x2: 78.0779,
				y2: -11.3577,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: 324998e-9,
						stopColor: "#5AD7F4"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .1404,
						stopColor: "#56CEEF"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .3724,
						stopColor: "#49B4E1"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .5674,
						stopColor: "#3D9AD2"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8652,
						stopColor: "#0075BE"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .9946,
						stopColor: "#005B97"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_611_11110",
				x1: 22.3902,
				y1: 44.3304,
				x2: 78.0783,
				y2: -11.3578,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: 324998e-9,
						stopColor: "#5AD7F4"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .1404,
						stopColor: "#56CEEF"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .3724,
						stopColor: "#49B4E1"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .5674,
						stopColor: "#3D9AD2"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8652,
						stopColor: "#0075BE"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .9946,
						stopColor: "#005B97"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_611_11110",
				x1: 22.3908,
				y1: 44.3302,
				x2: 78.079,
				y2: -11.358,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: 324998e-9,
						stopColor: "#5AD7F4"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .1404,
						stopColor: "#56CEEF"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .3724,
						stopColor: "#49B4E1"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .5674,
						stopColor: "#3D9AD2"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8652,
						stopColor: "#0075BE"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .9946,
						stopColor: "#005B97"
					})
				]
			})
		] })
	]
});
export default SvgLogoColorF;
